export default class extends Controller {
  static targets = ["fieldContainer", "link", "action"];

  revealField(event) {
    event.preventDefault();
    this.fieldContainerTarget.className = "active";
    this.linkAction = "hide";
    this.inputDisabled = false;
  }

  hideField(event) {
    event.preventDefault();
    this.fieldContainerTarget.className = "hidden";
    this.linkAction = "reveal";
    this.inputDisabled = true;
  }

  //
  // GETTERS AND SETTERS
  //

  set inputDisabled(value) {
    [...this.inputs].forEach(input => input.disabled = value ? "disabled" : null);
  }

  get inputs() {
    return this.element.querySelectorAll("input, textarea, select");
  }

  set linkAction(action) {
    this.linkTarget.setAttribute("data-action", `${this.identifier}#${action}Field`);
    this.actionTarget.className = `${action}-field`;
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/forms-fields-optional-field-controller.js